const myConfig= {
    DECRYPTION_SECRET_KEY: 'H1Nu9Ly7eF3sbCnYzj2YQr_JHC_HXI9KpXaBw0OqWSc=',
    DEFAULT_RANDOM_CODE: 'TsMK!V&3jgqWz#!w',
    ENCRYPTION_URL: 'https://hh1ori9ic7.execute-api.ap-south-1.amazonaws.com/encryptText',
}


export default myConfig;